module.exports = __webpack_public_path__ + "4b6781d9668cb1d9d0a9a653f2201473.png";